import React, { ReactElement, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Images
import footerLogoWhite from "../../../assets/images/remote-meeting-logo-white.png";

const Footer = (): ReactElement => {
  const location = useLocation();
  const [live, setIsLiveLocation] = useState(false);

  useEffect(() => {
    if (location.pathname == "/live") {
      setIsLiveLocation(true);
    }
  }, []);

  return (
    <footer id="tm__footer" className="mt-auto py-2">
      <div
        className={`container d-flex flex-column flex-md-row align-items-center justify-content-between ${
          live ? "container-custom" : ""
        }`}>
        <div className="d-flex flex-column flex-md-row align-items-center">
          <img
            src={footerLogoWhite}
            className="mb-2 mb-md-0"
            alt="Remote Meeting"
            width="110"
          />
          <span className="ms-3">
            Copyright &copy; Remote Meeting 2022 All Rights Reserved.
          </span>
        </div>
        <ul className="d-flex list-style-none p-0 m-0">
          <li>
            <a href="#">Privacy Policy</a>
          </li>
          <li>
            <a className="ms-3" href="#">
              Terms of Service
            </a>
          </li>
          <li>
            <a className="ms-3" href="#">
              Legal
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
